import { useStableCallback } from '@ipfabric/ui-components/hooks/useStableCallback';
import { prop } from '@ipfabric/utils/fp/prop';
import { DeviceViewSetupTables } from 'components/DeviceView/DeviceViewSetupTables/DeviceViewSetupTables';
import {
  type DeviceViewEntityId,
  isLabelsEntity,
} from 'components/DeviceView/deviceViewTypes';
import { type FC, memo, useState } from 'react';
import { useDeviceViewContextSelectors } from '../model/DeviceViewModel';
import { DeviceViewContentEntity } from './DeviceViewContentEntity';

interface Props {
  activeDeviceViewEntityId: DeviceViewEntityId;
  hideInactiveEntity?: boolean;
  nameSuffix: string;
}

const BareDeviceViewContent: FC<Props> = (props) => {
  const [showSetupTables, setShowSetupTables] = useState<boolean>(false);
  const ctxProps = useDeviceViewContextSelectors({
    deviceViewEntities: prop('deviceViewEntities'),
  });

  const handleShowSetupTables = useStableCallback(() => {
    setShowSetupTables(true);
  });

  const handleCloseSetupTables = useStableCallback(() => {
    setShowSetupTables(false);
  });

  const activeDeviceViewEntity = ctxProps.deviceViewEntities.find(
    (entity) => entity.id === props.activeDeviceViewEntityId,
  );

  return (
    <>
      {activeDeviceViewEntity !== undefined &&
        !isLabelsEntity(activeDeviceViewEntity) &&
        showSetupTables && (
          <DeviceViewSetupTables
            deviceViewEntity={activeDeviceViewEntity}
            onCloseSetupTables={handleCloseSetupTables}
          />
        )}
      {ctxProps.deviceViewEntities.map((deviceViewEntity) => (
        <DeviceViewContentEntity
          activeDeviceViewEntityId={props.activeDeviceViewEntityId}
          compareMode={
            deviceViewEntity.deviceViewElement === 'node' ||
            deviceViewEntity.deviceViewElement === 'edge'
              ? deviceViewEntity.compareMode
              : null
          }
          deviceViewEntity={deviceViewEntity}
          hideInactiveEntity={props.hideInactiveEntity}
          key={deviceViewEntity.id}
          nameSuffix={props.nameSuffix}
          onShowSetupTables={handleShowSetupTables}
        />
      ))}
    </>
  );
};

export const DeviceViewContent = memo(BareDeviceViewContent);
